import decode from 'jwt-decode';
import ApiService from 'services/ApiService';
import { Utils } from 'utils/UtilsDefault';

export default class AuthService {
  constructor() {
    this.login = this.login.bind(this);
    this.loginIntegracaoVoala = this.loginIntegracaoVoala.bind(this);
    this.logout = this.logout.bind(this);
    this.parseJwt = this.parseJwt.bind(this);
    this.getProfile = this.getProfile.bind(this);
  }

  login(user, password) {
    const dados = {
      dados: {
        user,
        password,
      },
    };

    return ApiService.user.loginUser(dados).then(res => {
      if (!res.data.Data || !res.data) {
        return null;
      }
      if (res.data.Data) {
        this.setToken(
          res.data.Data.Token,
          res.data.Data.TokenDuration,
          res.data.Data.PessoaAuth,
        );
      } else if (res.data) {
        this.setToken(
          res.data.token,
          res.data.tokenDuration,
          res.data.Data.PessoaAuth,
        );
      }
      return Promise.resolve(res);
    });
  }

  loginIntegracaoVoala(user, password) {
    const dadosLogin = {
      dados: {
        user: Utils.retirarFormatacao(user),
        password,
      },
    };

    return ApiService.user.loginUser(dadosLogin).then(res => {
      if (!res.data) {
        return null;
      }
      if (res.data.Data && !res.data.HasErrors) {
        this.setToken(
          res.data.Data.Token,
          res.data.Data.TokenDuration,
          res.data.Data.PessoaAuth,
        );
      } else if (res.data.HasErrors) {
        return Promise.reject(res.data.ReturnMessage);
      }
      return Promise.resolve(res.data.Data);
    });
  }

  registerUser(dataRegister) {
    const dadosLogin = { Dados: dataRegister };

    return ApiService.user.registerUser(dadosLogin).then(res => {
      if (!res.data) {
        return null;
      }
      if (res.data.HasErrors) {
        return Promise.reject(res.data.ReturnMessage);
      }
      if (res.data.Data) {
        this.setToken(
          res.data.Data.Token,
          res.data.Data.TokenDuration,
          res.data.Data.PessoaAuth,
        );
        if (
          res.data.Data.Token &&
          res.data.Data.TokenDuration &&
          res.data.Data.PessoaAuth
        ) {
          return Promise.resolve(res.data.Data);
        }
        return Promise.resolve(false);
      }
      return Promise.resolve(res.data.ReturnMessage);
    });
  }

  recoverPassword = codigoCpf => {
    const dadosCpf = { dados: Utils.retornaSomenteNumero(codigoCpf) };

    return ApiService.user.recoverPassword(dadosCpf).then(res => {
      if (!res.data) {
        return null;
      }
      if (res.data.Data && res.data.HasErrors) {
        return Promise.reject(res.data.ReturnMessage);
      }
      return Promise.resolve(res.data.ReturnMessage);
    });
  };

  changePassword = data => {
    const dataChangePassword = { dados: data };

    return ApiService.user.changePassword(dataChangePassword).then(res => {
      if (!res.data) {
        return null;
      }
      if (res.data.Data && res.data.HasErrors) {
        return Promise.reject(res.data.ReturnMessage);
      }
      return Promise.resolve(res.data.ReturnMessage);
    });
  };

  changeEmail(data) {
    const dataChangeEmail = { dados: data };

    return ApiService.user.changeEmail(dataChangeEmail).then(res => {
      if (Utils.isContentArray(res)) {
        this.changeEmailStorage(data.Email);
        return Promise.resolve(res);
      }
      if (!res.data) {
        return null;
      }
      if (res.data.Data && res.data.HasErrors) {
        return Promise.reject(res.data.ReturnMessage);
      }
      this.changeEmailStorage(data.Email);
      return Promise.resolve(res.data.ReturnMessage);
    });
  }

  changeEmailStorage = email => {
    const user = JSON.parse(localStorage.getItem('user'));
    user.email = email;
    localStorage.setItem('user', JSON.stringify(user));
  };

  passwordReset = data => {
    const dataChangePassword = { dados: data };

    return ApiService.user
      .passwordReset(dataChangePassword)
      .then(res => Promise.resolve(res))
      .catch(err => Promise.reject(err));
  };

  validTokePasswordReset = data => {
    const dataChangePassword = { dados: data };

    return ApiService.user
      .validTokenPasswordReset(dataChangePassword)
      .then(res => Promise.resolve(res))
      .catch(err => Promise.reject(err));
  };

  loggedIn(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    return !!token && !this.isTokenExpired();
  }

  isTokenExpired(): boolean {
    try {
      const tokenDuration = this.getTokenDuration();
      if (
        Utils.converterStringParaDate(tokenDuration).getTime() <
        Utils.getDate().getTime()
      ) {
        this.logout();
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  setToken = (idToken, tokenDuration, pessoaAuth) => {
    let telefone = null;
    if (pessoaAuth.Telefone != null) {
      telefone = pessoaAuth.Telefone;
    } else if (pessoaAuth.Endereco != null) {
      telefone = pessoaAuth.Endereco.Telefone;
    }

    const user = {
      idToken,
      tokenDuration,
      cpf: pessoaAuth.Cpf,
      email: pessoaAuth.Email,
      id: pessoaAuth.Id,
      funcionario: pessoaAuth.Funcionario,
      nascimento: pessoaAuth.Nascimento,
      primeiroNome: pessoaAuth.PrimeiroNome,
      sexo: pessoaAuth.Sexo,
      ultimoNome: pessoaAuth.UltimoNome,
      avatar: pessoaAuth.Foto,
      telefone,
      cep: pessoaAuth.Endereco != null ? pessoaAuth.Endereco.Cep : null,
      cidade: pessoaAuth.Endereco != null ? pessoaAuth.Endereco.Cidade : null,
      numeroEndereco:
        pessoaAuth.Endereco != null ? pessoaAuth.Endereco.NumeroEndereco : null,
      estado: pessoaAuth.Endereco != null ? pessoaAuth.Endereco.Estado : null,
      logradouro:
        pessoaAuth.Endereco != null ? pessoaAuth.Endereco.Logradouro : null,
    };

    window.localStorage.setItem('user', JSON.stringify(user));
  };

  getTokenDuration = () => {
    const duration = JSON.parse(window.localStorage.getItem('user'));
    if (duration && duration.tokenDuration) {
      return duration.tokenDuration;
    }
    return false;
  };

  getToken = () => {
    let token = null;
    if (window.localStorage.getItem('user')) {
      token = JSON.parse(window.localStorage.getItem('user'));
      if (token && token.idToken) {
        return token.idToken;
      }
      return '';
    }
    return '';
  };

  getClient = () => {
    return JSON.parse(window.localStorage.getItem('user'));
  };

  getUserCPF = () => {
    if (window.localStorage.getItem('user')) {
      const user = JSON.parse(window.localStorage.getItem('user'));
      if (user && user.cpf) {
        return user.cpf;
      }
    }
    return false;
  };

  setUserAvatar = imageAvatar => {
    if (window.localStorage.getItem('user')) {
      const user = JSON.parse(window.localStorage.getItem('user'));
      user.avatar = imageAvatar;
      window.localStorage.setItem('user', JSON.stringify(user));
      return true;
    }
    return false;
  };

  getUserAvatar = () => {
    if (window.localStorage.getItem('user')) {
      const user = JSON.parse(window.localStorage.getItem('user'));
      if (user && user.avatar) {
        return user.avatar;
      }
    }
    return false;
  };

  isFuncionario = () => {
    if (window.localStorage.getItem('user')) {
      const user = JSON.parse(window.localStorage.getItem('user'));
      if (user && user.funcionario) {
        return user.funcionario;
      }
    }
    return false;
  };

  logout = () => {
    window.localStorage.removeItem('user');
  };

  getProfile() {
    return decode(this.getToken());
  }

  parseJwt = token => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  };

  getDataUser = () => {
    let defaultValues = null;
    if (this.loggedIn()) {
      const user = this.getClient();

      if (!user.ultimoNome) {
        user.ultimoNome = Utils.retornaSobrenome(user.primeiroNome);
        user.primeiroNome = Utils.retornaNome(user.primeiroNome);
      }

      if (user.primeiroNome.split(' ').length > 1) {
        user.ultimoNome = `${Utils.retornaSobrenome(user.primeiroNome)} ${
          user.ultimoNome
        }`;
        user.primeiroNome = Utils.retornaNome(user.primeiroNome);
      }

      let sexo = null;
      if (user.sexo && user.sexo === 'M') {
        sexo = 'masculino';
      } else if (user.sexo && user.sexo === 'F') {
        sexo = 'feminino';
      }

      defaultValues = {
        Documento: user.cpf ? Utils.mascaraCpf(user.cpf) : null,
        DocumentoIdentificacao: 'cpf',
        Email: user.email ? user.email : null,
        Nome: user.primeiroNome ? user.primeiroNome : null,
        Pais: '55',
        Sexo: sexo,
        Sobrenome: user.ultimoNome ? user.ultimoNome : null,
        DataNascimento: user.nascimento
          ? Utils.retonaDiaEMesEAno(user.nascimento)
          : null,
        Numero: user.numeroEndereco ? user.numeroEndereco : null,
        NumeroTelefone: user.telefone ? user.telefone : null,
        TipoTelefone: null,
        cep: user.cep ? user.cep : null,
        PontoReferencia: null,
      };
    }
    return defaultValues;
  };
}
